import * as React from 'react'
import IframeResizer from 'iframe-resizer-react'
import i18next from 'i18next'

export type IframeProps = {
  url: string
}

type IframeState = {
  status: 'loading' | 'done'
}

export class Iframe extends React.Component<IframeProps, IframeState> {
  private iframe: React.RefObject<HTMLIFrameElement> | null = null

  constructor(props: IframeProps) {
    super(props)

    this.iframe = React.createRef()

    this.state = {
      status: 'loading'
    }

    this.handleIFrameLoad = this.handleIFrameLoad.bind(this)
    this.handleIFrameResize = this.handleIFrameResize.bind(this)
  }

  componentDidMount() {
    this.handleIFrameResize()
    window.addEventListener('resize', this.handleIFrameResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleIFrameResize)
  }

  handleIFrameResize() {
    if (this.iframe && this.iframe.current?.classList.contains('iframe-unresized')) {
      const iframe = this.iframe.current

      if(iframe.src.includes('anbigift')) {
        const windowSize = window.innerWidth

        if(windowSize <= 480) {
          iframe.height = '940px'
        } else if(windowSize > 480 && windowSize <= 640) {
          iframe.height = '840px'
        } else if(windowSize > 480 && windowSize <= 1060) {
          iframe.height = '650px'
        } else if(windowSize > 1060 && windowSize <= 1200) {
          iframe.height = '500px'
        } else {
          iframe.height = '480px'
        }
      }
    }
  }

  handleIFrameLoad() {
    this.setState((s) => ({ ...s, status: 'done' }))
  }

  render() {
    return (
      <>
        {this.props.url != '' && this.state.status === 'loading' && (
          <p className='iframe-loading'>{i18next.t('General:IframeLoading')}</p>
        )}

        {this.props.url.includes('anbigift') ? (
          <>
            <iframe
              ref={this.iframe}
              id="iframe-unresized"
              className='iframe-unresized show'
              style={{ width: '1px', minWidth: '100%', minHeight: '480px' }}
              src={this.props.url != '' ? this.props.url : ''}
              loading='lazy'
              onLoad={this.handleIFrameLoad}
            />
          </>
        ) : (
          <IframeResizer
            id="iframe-resized"
            className='iframe'
            style={{ width: '1px', minWidth: '100%'}}
            src={this.props.url != '' ? this.props.url : ''}
            loading='lazy'
            onLoad={this.handleIFrameLoad}
            onResized={(e) => e.iframe.classList.add('show')}
          />
        )}        
      </>
    )
  }
}
